import {FC} from 'react'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {useQuery} from 'hooks/graphql'
import {dayOrTimeFormat} from 'libs/formatter'
import {FlatCard, FlatCardHeader, FlatCardTitle, FlatCardBody, FlatCardListItem, FlatCardListArrow} from '../FlatCard'
import {SeeMoreButton} from '../SeeMoreButton'
import {SYSTEM_ANNOUNCES, SystemAnnounce, SystemAnnouncesQueryVariables, SystemAnnouncesQueryResult} from './query'
import styles from './SystemAnnounces.scss'

const MAX_COUNT = 5
const NEW_LABEL_LIMIT = 7

interface SystemAnnounceProps {
  systemAnnounce: SystemAnnounce
}

const SystemAnnounceItem: FC<SystemAnnounceProps> = ({systemAnnounce}) => {
  const dateOrTime = dayOrTimeFormat(systemAnnounce.publishAt)
  const today = moment()
  const publishAt = moment(systemAnnounce.publishAt)
  const dateDiff = today.diff(publishAt, 'days')

  const children = (
    <>
      <span className={styles.date}>
        {dateDiff <= NEW_LABEL_LIMIT && <span className={styles.new}></span>}
        {dateOrTime}
      </span>
      <span className={dateDiff <= NEW_LABEL_LIMIT ? styles.newAnnounceTitle : styles.announceTitle}>
        {systemAnnounce.title}
      </span>
      <FlatCardListArrow />
    </>
  )

  return systemAnnounce.systemAnnounceType === 'link' ? (
    <FlatCardListItem as="a" href={systemAnnounce.link} target="_blank">
      {children}
    </FlatCardListItem>
  ) : (
    <FlatCardListItem as={Link} to={`system_announces/${systemAnnounce.id}`}>
      {children}
    </FlatCardListItem>
  )
}

export const SystemAnnounces: FC = () => {
  const {data, loading} = useQuery<SystemAnnouncesQueryResult, SystemAnnouncesQueryVariables>(SYSTEM_ANNOUNCES, {
    variables: {per: MAX_COUNT},
    fetchPolicy: 'network-only',
  })
  const available = !loading && data

  return (
    <FlatCard>
      <FlatCardHeader border>
        <FlatCardTitle>お知らせ</FlatCardTitle>
        <SeeMoreButton to={available && data.systemAnnounces.totalCount > 0 ? '/system_announces' : undefined}>
          すべて見る
        </SeeMoreButton>
      </FlatCardHeader>
      <FlatCardBody className={styles.cardBody} cramp>
        {available &&
          (data.systemAnnounces.totalCount > 0 ? (
            data.systemAnnounces.list.map((systemAnnounce) => (
              <SystemAnnounceItem key={systemAnnounce.id} systemAnnounce={systemAnnounce} />
            ))
          ) : (
            <FlatCardListItem className={styles.empty}>お知らせはまだありません</FlatCardListItem>
          ))}
      </FlatCardBody>
    </FlatCard>
  )
}
